import React from "react";

/**
 * BrandLogo — renders the official Knya app icon.
 * Use `variant="icon"` (default) for the rounded app-icon mark used in headers,
 * or `variant="wordmark"` for the full logotype (login / splash).
 *
 * The app icon already ships with its own soft rounded background; we render it
 * inside a rounded container so it looks crisp on every surface (cream, dark hero, etc.).
 */
export default function BrandLogo({
  variant = "icon",
  size = 36,
  className = "",
  alt = "Knya",
  rounded = true,
  ...rest
}) {
  if (variant === "wordmark") {
    return (
      <img
        src="/knya-wordmark.svg"
        alt={alt}
        height={size}
        style={{ height: size, width: "auto" }}
        className={`select-none ${className}`}
        draggable={false}
        data-testid="brand-wordmark"
        {...rest}
      />
    );
  }
  return (
    <img
      src="/knya-icon.png"
      alt={alt}
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={`select-none ${rounded ? "rounded-[22%]" : ""} ${className}`}
      draggable={false}
      data-testid="brand-icon"
      {...rest}
    />
  );
}
